import clsx from 'clsx';
import React, { ButtonHTMLAttributes, ForwardedRef, forwardRef } from 'react';
import './IconButton.less';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  withShadow?: boolean;
  unstyled?: boolean;
}

const IconButton = forwardRef<HTMLButtonElement, Props>(
  (
    { children, withShadow, unstyled, ...props },
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    if (unstyled) {
      return (
        <button
          {...props}
          ref={ref}
          className={clsx('icon-button_unstyled', props.className)}
        >
          {children}
        </button>
      );
    }

    return (
      <button
        {...props}
        ref={ref}
        className={clsx(
          'icon-button',
          {
            'icon-button_with-shadow': withShadow,
          },
          props.className,
        )}
      >
        {children}
      </button>
    );
  },
);

export default IconButton;
